export default "__VITE_ASSET__AwD6iKjp__"